<button class="db-percent-offer__toggle" [ngClass]="{'active': isToggled && blkOffer}" (click)="toggleBanner()">
  <span *ngIf="!blkOffer">Save {{percent}}% on annual plans</span>

  <span *ngIf="blkOffer">{{blkDiscount}}% exclusive discount
        <b><i class="db-icon db-icon-ds-timer mr2"></i>{{timeLeft}}{{countDownUnit}}</b>
  </span>
</button>
<db-percent-offer-banner *ngIf="isToggled" [blkOffer]="blkOffer" [userSubscription]="userSubscription"
                         [demoUser]="demoUser"
                         [oneWeekFreeExpired]="oneWeekFreeExpired"
                         [oneWeekFreeNotExpired]="oneWeekFreeNotExpired"
                         [paidNotExpired]="paidNotExpired"
                         [hideButton]="hideButton"
                         (onClaimOffer)="claimOffer()"></db-percent-offer-banner>
